/* YLW Questionnaire. Built by TJ Double You, Oct 2026, from the Skin Read Quiz's screens.
   Runs the questionnaire sections on a page (ylw-qn-part, ylw-qn-breaker, ylw-qn-email,
   ylw-qn-end) in page order, one screen at a time. No scores, no branches, no results.
   Progress rail: one lozenge per part, plus one each for the email screen and the end when they
   have a name. A part's questions light its own lozenge, a named email screen lights its own,
   and anything else (a breaker, an unnamed email screen) lights the next one.
   Klaviyo: the email screen subscribes the email to its list when the box is ticked; one event
   carrying every question and its answer is sent when the last question or email screen is done.
   When the email screen has a product or link, unlocking sends the event and goes straight there.
   All wording is rendered by the sections, so this file holds behaviour only.
   In the theme editor: selecting a question, breaker, email screen or end shows it, breakers
   hold while selected, and nothing is sent to Klaviyo. */
(function () {
  'use strict';
  if (window.YLWQN) return;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var Q = window.YLWQN = { steps: [], stamps: [], cur: null, curKey: '', answers: {}, email: '', consent: false, sent: false, leaving: false, timers: [], startedAt: new Date().toISOString() };

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function questions() { return Q.steps.filter(function (s) { return s.dataset.qnStep === 'question'; }); }
  function inputs() { return Q.steps.filter(function (s) { return s.dataset.qnStep === 'question' || s.dataset.qnStep === 'email'; }); }
  function clearTimers() { Q.timers.forEach(clearTimeout); Q.timers = []; }
  function later(fn, ms) { Q.timers.push(setTimeout(fn, ms)); }
  function err(step, msg) { var e = step.querySelector('.qn-err'); if (e) e.textContent = msg; }
  function mark(name, state) { document.documentElement.setAttribute('data-qn-' + name, state); }

  function collect() {
    Q.steps = all('[data-qn-step]');
    Q.stamps = all('.ylw-qn.qn-part, .ylw-qn.qn-email, .ylw-qn.qn-end').filter(function (s) {
      return s.classList.contains('qn-part') || s.dataset.qnLabel;
    });
    /* The first question carries the big opening heading; later parts' headings stay small. */
    var first = questions()[0];
    Q.steps.forEach(function (s) { s.classList.toggle('qn-first', s === first); });
  }

  /* A step's identity survives the theme editor re-rendering its section: the block id for a
     question, the section's wrapper id for anything else. */
  function keyOf(step) {
    var sec = step.closest('.shopify-section');
    return step.dataset.block || (sec ? sec.id : '');
  }
  function byKey(key) {
    if (!key) return null;
    var q = document.querySelector('[data-qn-step][data-block="' + key + '"]');
    if (q) return q;
    var sec = document.getElementById(key);
    return sec ? sec.querySelector('[data-qn-step]') : null;
  }

  function paintRail(step) {
    var rail = step.querySelector('[data-qn-rail]');
    if (!rail) return;
    var stamps = Q.stamps;
    if (stamps.length < 2) { rail.innerHTML = ''; rail.hidden = true; return; }
    var own = stamps.indexOf(step.closest('.ylw-qn')), cur = stamps.length;
    if (own > -1) cur = own;
    else {
      for (var i = 0; i < stamps.length; i++) {
        if (step.compareDocumentPosition(stamps[i]) & Node.DOCUMENT_POSITION_FOLLOWING) { cur = i; break; }
      }
    }
    rail.hidden = false;
    rail.innerHTML = stamps.map(function (s, i) {
      var cls = i < cur ? ' done' : i === cur ? ' on' : '';
      var label = s.dataset.qnLabel ? '<span>' + esc(s.dataset.qnLabel) + '</span>' : '';
      return '<span class="qn-stamp' + cls + '"><b>' + (i < cur ? '✓' : i + 1) + '</b>' + label + '</span>';
    }).join('');
  }

  function show(step, hold) {
    if (!step) return;
    clearTimers();
    Q.leaving = false;
    Q.cur = step;
    Q.curKey = keyOf(step);
    Q.steps.forEach(function (s) { s.classList.toggle('is-on', s === step); });
    paintRail(step);
    var type = step.dataset.qnStep;
    if (type === 'question') paintQuestion(step);
    if (type === 'email') paintEmail(step);
    if (type === 'breaker') runBreaker(step, hold);
    if (!design) {
      window.scrollTo(0, 0);
      var h = step.querySelector('h1, h2, .qn-fact');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }
  }

  function paintBack(step) {
    var back = step.querySelector('[data-qn-back]');
    if (back) back.hidden = inputs().indexOf(step) <= 0;
  }

  function paintQuestion(step) {
    var qs = questions(), n = qs.indexOf(step) + 1;
    var count = step.querySelector('[data-qn-count]'), bar = step.querySelector('[data-qn-bar]');
    if (count) count.textContent = 'Question ' + n + ' of ' + qs.length;
    if (bar) bar.style.width = Math.round(n / qs.length * 100) + '%';
    paintBack(step);
    var a = Q.answers[step.dataset.block];
    all('.qn-opt', step).forEach(function (o) {
      var on = Array.isArray(a) ? a.indexOf(o.dataset.a) > -1 : a === o.dataset.a;
      o.setAttribute('aria-pressed', String(on));
    });
    var input = step.querySelector('.qn-input');
    if (input) input.value = typeof a === 'string' ? a : '';
    syncNext(step);
    err(step, '');
  }

  function paintEmail(step) {
    paintBack(step);
    var input = step.querySelector('.qn-input'), tick = step.querySelector('.qn-consent');
    if (input) input.value = Q.email;
    if (tick) tick.checked = Q.consent;
    err(step, '');
  }

  /* Multiple choice: Next stays off until something is picked, when an answer is required. */
  function syncNext(step) {
    if (step.dataset.type !== 'multi') return;
    var nx = step.querySelector('[data-qn-next]'), a = Q.answers[step.dataset.block];
    if (nx) nx.disabled = step.dataset.required === 'true' && !(a && a.length);
  }

  function runBreaker(step, hold) {
    var dur = parseInt(step.dataset.dur, 10) || 4000;
    var lines = all('.qn-lines li', step).map(function (li) { return li.textContent; });
    var status = step.querySelector('.qn-status'), fg = step.querySelector('.qn-spin .fg');
    step.style.setProperty('--qn-dur', dur + 'ms');
    step.classList.toggle('qn-hold', !!hold);
    if (fg) { fg.classList.remove('run'); fg.getBoundingClientRect(); fg.classList.add('run'); }
    function say(t) {
      if (!status) return;
      status.classList.remove('in'); void status.offsetWidth;
      status.textContent = t; status.classList.add('in');
    }
    say(lines[0] || '');
    if (hold) {
      /* Held in the editor: keep cycling the lines so each one can be seen. */
      var k = 0, gap = Math.max(1200, Math.round(dur / Math.max(lines.length, 1)));
      (function loop() { later(function () { k = (k + 1) % Math.max(lines.length, 1); say(lines[k] || ''); loop(); }, gap); })();
      return;
    }
    lines.slice(1).forEach(function (t, k) { later(function () { say(t); }, Math.round(dur * (k + 1) / lines.length)); });
    later(next, dur + 300);
  }

  function next() {
    var ins = inputs();
    if (Q.cur && Q.cur === ins[ins.length - 1]) send();
    var to = Q.steps[Q.steps.indexOf(Q.cur) + 1];
    if (to) show(to);
  }
  function back() {
    var ins = inputs(), k = ins.indexOf(Q.cur);
    if (k > 0) show(ins[k - 1]);
  }

  function pick(step, o) {
    var id = step.dataset.block, v = o.dataset.a;
    if (step.dataset.type === 'multi') {
      var a = (Q.answers[id] || []).slice(), at = a.indexOf(v);
      if (at > -1) a.splice(at, 1); else a.push(v);
      Q.answers[id] = a;
      o.setAttribute('aria-pressed', String(at === -1));
      syncNext(step);
      err(step, '');
      return;
    }
    if (Q.leaving) return;
    Q.leaving = true;
    Q.answers[id] = v;
    all('.qn-opt', step).forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
    later(next, 180);
  }

  function submit(step) {
    if (step.dataset.qnStep === 'email') return submitEmail(step);
    var id = step.dataset.block, type = step.dataset.type, req = step.dataset.required === 'true';
    if (type === 'multi') {
      if (req && !(Q.answers[id] || []).length) return err(step, 'Pick at least one to carry on.');
      return next();
    }
    var input = step.querySelector('.qn-input'), v = input ? input.value.trim() : '';
    if (req && !v) return err(step, 'Please answer to carry on.');
    if (v) Q.answers[id] = v; else delete Q.answers[id];
    next();
  }

  function submitEmail(step) {
    var input = step.querySelector('.qn-input'), tick = step.querySelector('.qn-consent');
    var v = input ? input.value.trim() : '';
    if (!EMAIL.test(v)) return err(step, 'That email doesn’t look right.');
    if (tick && step.dataset.tickRequired === 'true' && !tick.checked) return err(step, 'Tick the box to continue.');
    Q.email = v;
    Q.consent = !!(tick && tick.checked);
    var box = step.closest('.qn-email'), list = box.dataset.qnList, go = box.dataset.qnGo;
    if (Q.consent && list && !design) subscribe(cfg().company, list, v);
    /* Straight to the product: send what has been answered so far, then leave. Both Klaviyo
       calls use keepalive, so they finish after the page has gone. Not in the theme editor. */
    if (go && !design) {
      send();
      window.location.assign(go);
      return;
    }
    next();
  }

  /* ---------- Klaviyo ---------- */
  /* The Klaviyo settings sit on the email screen; with none on the page, the defaults apply. */
  function cfg() {
    var box = document.querySelector('.ylw-qn.qn-email'), head = document.querySelector('.ylw-qn[data-qn-template]');
    return {
      company: (box && box.dataset.qnKlaviyo) || 'RQvFjd',
      event: (box && box.dataset.qnEvent) || 'Completed Questionnaire',
      template: head ? head.dataset.qnTemplate : '',
      page: head ? head.dataset.qnPage : ''
    };
  }

  function kPost(company, path, body, name) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) return mark(name, 'ok');
      return r.text().then(function (t) { mark(name, 'failed ' + r.status); console.warn('[ylw-qn] Klaviyo ' + path, r.status, t.slice(0, 300)); });
    }).catch(function (e) { mark(name, 'failed'); console.warn('[ylw-qn]', e); });
  }

  /* Same call as the Skin Read Quiz's sign-up: email marketing consent on the chosen list. */
  function subscribe(company, list, email) {
    var c = cfg();
    kPost(company, 'subscriptions', { data: { type: 'subscription', attributes: {
      custom_source: 'Questionnaire: ' + c.template,
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: list } } } } }, 'subscribe');
  }

  function event(c, props, who) {
    var body = { data: { type: 'event', attributes: {
      properties: props,
      metric: { data: { type: 'metric', attributes: { name: c.event } } },
      profile: { data: { type: 'profile', attributes: who } }
    } } };
    return kPost(c.company, 'events', body, 'klaviyo');
  }

  /* Property names: "Q " + the question's Klaviyo name. Two questions with the same name get
     " (2)", " (3)" in page order, worked out over every question so the names never shift
     with which ones were skipped. */
  function propNames() {
    var seen = {}, out = {};
    questions().forEach(function (s) {
      var base = 'Q ' + (s.dataset.key || 'Question'), k = base, n = 2;
      while (seen[k]) k = base + ' (' + n++ + ')';
      seen[k] = 1;
      out[s.dataset.block] = k;
    });
    return out;
  }

  function anonId() {
    var id = '';
    try { id = localStorage.getItem('ylw_qn_anon') || ''; } catch (e) {}
    if (!id) {
      id = 'ylwqn-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
      try { localStorage.setItem('ylw_qn_anon', id); } catch (e) {}
    }
    return id;
  }

  function send() {
    if (Q.sent || design) return;
    Q.sent = true;
    var c = cfg();
    var props = { 'Questionnaire': c.template, 'Questionnaire Page': c.page, 'Questionnaire Started At': Q.startedAt };
    if (Q.steps.some(function (s) { return s.dataset.qnStep === 'email'; })) props['Marketing Consent'] = Q.consent;
    var names = propNames();
    questions().forEach(function (s) {
      var a = Q.answers[s.dataset.block];
      if (a === undefined || a === '' || (Array.isArray(a) && !a.length)) return;
      /* Multiple choice answers go in the order they appear on screen, joined with commas. */
      if (Array.isArray(a)) a = all('.qn-opt', s).map(function (o) { return o.dataset.a; }).filter(function (v) { return a.indexOf(v) > -1; }).join(', ');
      props[names[s.dataset.block]] = a;
    });

    if (Q.email) return event(c, props, { email: Q.email });
    /* No email screen: use the visitor Klaviyo already knows (they came from a Klaviyo email,
       say), or else an anonymous id kept in this browser. */
    var kl = window.klaviyo;
    if (kl && typeof kl.isIdentified === 'function') {
      Promise.resolve(kl.isIdentified()).then(function (known) {
        if (!known) return event(c, props, { anonymous_id: anonId() });
        return Promise.resolve(kl.track(c.event, props)).then(function () { mark('klaviyo', 'ok onsite'); });
      }).catch(function () { event(c, props, { anonymous_id: anonId() }); });
    } else {
      event(c, props, { anonymous_id: anonId() });
    }
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.ylw-qn button') : null;
    if (!b) return;
    var step = b.closest('[data-qn-step]');
    if (!step || step !== Q.cur) return;
    if (b.classList.contains('qn-opt')) return pick(step, b);
    if (b.hasAttribute('data-qn-next')) return submit(step);
    if (b.hasAttribute('data-qn-skip')) { delete Q.answers[step.dataset.block]; return next(); }
    if (b.hasAttribute('data-qn-back')) return back();
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key !== 'Enter' || !t.classList || !t.classList.contains('qn-input')) return;
    e.preventDefault();
    var step = t.closest('[data-qn-step]');
    if (step === Q.cur) submit(step);
  });
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('qn-consent') && Q.cur) err(Q.cur, '');
  });

  if (design) {
    document.addEventListener('shopify:section:load', function (e) {
      collect();
      show(byKey(Q.curKey) || e.target.querySelector('[data-qn-step]') || Q.steps[0], true);
    });
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(function () { collect(); if (!document.contains(Q.cur)) show(byKey(Q.curKey) || Q.steps[0], true); }, 0);
    });
    document.addEventListener('shopify:section:reorder', function () { collect(); show(Q.cur, true); });
    document.addEventListener('shopify:section:select', function (e) {
      collect();
      var s = e.target.querySelector('[data-qn-step]');
      if (s) show(s, true);
    });
    document.addEventListener('shopify:block:select', function (e) {
      collect();
      var s = e.target.closest('[data-qn-step]');
      if (s) show(s, true);
    });
  }

  function init() { collect(); show(Q.steps[0]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
